import { createAsyncThunk } from '@reduxjs/toolkit';
import { validateAirport } from '@/libs/validation/validateAirport';
import { FlightField } from './interface';
import { flightsActions } from './index';
export const setFlightFrom = createAsyncThunk('flights/setFlightFrom', async ({ _uuid, value, code }, thunkApi) => {
    const isValueInList = !!code;
    const { error } = await validateAirport(value, { isValueInList });
    thunkApi.dispatch(flightsActions._setFlightField({
        _uuid,
        field: FlightField.from,
        value,
    }));
    thunkApi.dispatch(flightsActions._setFlightCode({
        _uuid,
        field: 'fromCode',
        code,
    }));
    thunkApi.dispatch(flightsActions._setFlightFieldError({
        _uuid,
        field: FlightField.from,
        error,
    }));
});
